export const PROFILE_SECURITY_API_CACHE_KEY = 'profile-inquery';